import { Component, OnInit } from '@angular/core';
import { PersoneriaJuridicaService } from '@asambleas-services/personeria-juridica/personeria-juridica.service';
import { environment } from '@asambleas-env/environment';
import { UserService } from '@asambleas-services/user/user.service';
import { LoadService } from '@asambleas-components/loader/loader.service';
import { MatSnackBar, MatDialog } from '@angular/material';
import { ConfirmComponent } from '@asambleas-components/confirm/confirm.component';

@Component({
  selector: 'app-solicitar-personeria-juridica',
  templateUrl: './solicitar-personeria-juridica.component.html',
  styleUrls: ['./solicitar-personeria-juridica.component.scss']
})
export class SolicitarPersoneriaJuridicaComponent implements OnInit {

  public user: any;

  public formularioFile: string;
  public cedulaFile: string;
  public credencialFile: string;

  constructor(private _personeriaJuridicaService: PersoneriaJuridicaService,
    private _userService: UserService,
    private loadService: LoadService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.getUserFiles();

    this.user = this._userService.getUser();
  }

  getUserFiles() {
    this._personeriaJuridicaService.getUserFiles()
      .subscribe((data: string[]) => {

        this.formularioFile = this.getFile('formulario', data);
        this.cedulaFile = this.getFile('cedula', data);
        this.credencialFile = this.getFile('credencial', data);
      }, (error) => {
        console.error('Lo sentimos, hubo un error');
      })
  }

  getFile(termino: string, userFiles: string[]): string {
    let response: string = null;

    userFiles.forEach((userFile) => {
      if (userFile.includes(`(${termino})`)) {
        response = userFile;
      }
    })

    return response;
  }

  getUrlFile(name: string) {

    let nameArray = name.split('.');

    return `${environment.apiEndPoint}/personeria-juridica/get-userfile/${this.user.id}/${nameArray[0]}/${nameArray[1]}`;
  }

  getUrlFormulario() {
    return `${environment.apiEndPoint}/personeria-juridica/formulario`;
  }

  onFileChanged(event, type: string) {

    const file = event.target.files[0];

    if (!file) {
      return;
    }

    let reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = () => {

      this.uploadFile(file, type);
    }
  }

  uploadFile(file: File, type: string) {

    let formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('type', type);

    let loader = this.loadService.createLoad('');

    loader.open();

    this._personeriaJuridicaService.uploadUserFile(formData)
      .subscribe((response) => {

        loader.close();

        this.getUserFiles();

        this.snackBar.open('Archivo subido exitosamente', 'Cerrar', {
          duration: 5000
        });
      }, (error) => {

        loader.close();
      })

  }

  canSendRequest(): boolean {
    if (this.formularioFile && this.cedulaFile && this.credencialFile && this.user.status_personeria_juridica == 0) {
      return true;
    }
    else {
      return false;
    }
  }

  sendRequest() {

    const ref = this.dialog.open(ConfirmComponent, { data: { title: 'Personería Jurídica', content: '¿Está seguro de solicitar personería jurídica', btnAgree: 'Solicitar', btnDisagree: 'Cancelar' } });

    ref.afterClosed()
      .subscribe((response) => {
        if (response.return) {

          let loader = this.loadService.createLoad('');
          loader.open();

          this._personeriaJuridicaService.sendRequest({})
            .subscribe((data) => {

              loader.close();

              this.user.status_personeria_juridica = 1;
              this._userService.setUserLocalStorage(this.user);

              this.snackBar.open('Solicitud envíada exitosamente', 'Cerrar', {
                duration: 5000
              });

            }, (error) => {

              loader.close();
              this.snackBar.open('Lo sentimos, hubo un error', 'Cerrar', {
                duration: 5000
              });
            })
        }
      })

  }

}



// WEBPACK FOOTER //
// ./src/app/components/solicitar-personeria-juridica/solicitar-personeria-juridica.component.ts